module.exports = __webpack_public_path__ + "img/home.6433713b.png";